<template>
  <modal :title="$t(title)" :visible.sync="isShowDialog" width="50%" append-to-body>
    <div class="contentDio" v-loading="detailLoading">
      <!-- 详细信息 -->
      <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
      <div class="detailMsg">
        <BaseList
          :baseMsg="baseMsg"
          :isMode.sync="isMode"
          :locationList="locationList"
          :groupList="groupList"
          ref="BaseList"
          @saveDecFn="saveDecFn"
        />
        <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
        <!-- <changeIcon :isMode="isMode" @modeChange="modeChange" /> -->
      </div>
      <template v-if="tabsArray.length">
        <Tabs
          :tabs="tabsArray"
          :activeCom.sync="TabsActive"
          @handleTabs="handleTabs"
        />
        <keep-alive>
          <component
            :is="TabsActive"
            v-bind="$attrs"
            :detailData="detailData"
            :calibrationInfo="calibrationInfo"
          />
        </keep-alive>
      </template>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false">
        {{ $t('buttonTitle.Close') }}
      </el-button>
      <el-button
        type="primary"
        @click="historyFn"
        v-if="sensorWay !== 'unknown'"
      >
        {{ $t('device.history_data') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue'
import EscalRule from '@/pages/equipment/publicCom/EscalRule.vue'
import NetParam from '@/pages/equipment/publicCom/NetParam.vue'
// import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Application from '@/pages/equipment/publicCom/Application.vue'
import Upload from '@/pages/equipment/publicCom/Upload.vue'
import resultHandle from '@/common/resultHandle'

import BaseList from './component/BaseList.vue'

import { sensorUpdateSensor } from '@/api/modules/sensor.js'
import bus from '@/utils/bus'
import { sensorHistory } from '@/utils/winDetail'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
import { getTabs } from '@/components/dialog/sensorDetail/tabController'
import SoundLightAlarm from './tabs/SoundLightAlarm.vue'
import GpsLocate from '@/components/dialog/sensorDetail/component/tabs/GpsLocate.vue'

import Calibration from '@/pages/equipment/publicCom/Calibration.vue'

export default {
  props: {
    title: {},
    isShowDetail: {},
    detailLoading: {},
    baseMsg: {
      type: Array
    },
    detailObj: {},
    sensorWay: {
      default: 'bind'
    },
    // 全对象
    detailData: {},

    calibrationInfo: {},
    locationList:{
      type: Array
    },
    groupList:{
      type: Array
    },
  },
  watch: {
    detailObj (newVal) {
      this.isMode = false

      this.Upload = {
        imageUrl: { ...newVal }.pictureBase64,
        // 图片后缀
        imageSuffix: { ...newVal }.pictureSuffix
      }
      this.tabsArray = getTabs(newVal.type)
      if (this.tabsArray.length) {
        this.TabsActive = this.tabsArray[0].name
      }
    }
  },
  created () {

  },
  computed: {

    isShowDialog: {
      get: function () {
        return this.isShowDetail
      },
      set: function (val) {
        this.$emit('update:isShowDetail', val)
      }
    }
  },
  components: {
    Tabs,
    BaseList,
    Upload,
    // changeIcon,
    Application,
    EscalRule,
    NetParam,
    SoundLightAlarm,
    GpsLocate,
    Calibration
  },
  data () {
    return {
      detailArray: [],

      isEdit: true,
      // 详细信息
      detailTbs: [
        {
          name: 'Detail',
          label: 'public.detail_info'
        }
      ],
      Dactive: 'Detail',
      // 图片
      Upload: {},
      // 设备tabs
      tabsArray: [],
      TabsActive: 'Application',
      // 模式切换
      isMode: false
    }
  },

  methods: {
    // modeChange() {
    //     this.isMode = !this.isMode;
    //     this.$refs['BaseList'].areaValue = this.baseMsg[this.baseMsg.length - 1]['content'];
    //     this.$refs['BaseList'].nickname = this.baseMsg[this.baseMsg.length - 2]['content'];
    // },
    saveDecFn (row) {
      const { imageSuffix, imageUrl } = this.$refs.upload.newUpload
      sensorUpdateSensor({
        id: this.detailObj.id,
        locationId: row.locationId,
        groupId: row.groupId,
        nickname: row.nickname,
        description: row.areaValue,
        uploadFileBase64: imageUrl,
        uploadFileSuffix: imageSuffix
      }).then(async ({ state }) => {
        await resultHandle(state)
        this.isEdit = !this.isEdit
        this.isMode = !this.isMode
        // this.$emit('changdetail', this.detailObj);
        bus.$emit('sensorParam', this.detailObj.id, this.detailObj.tagId)
        this.isMode = !this.isMode
      })
    },
    isEditFn () {
      this.isEdit = !this.isEdit
      this.$children.areaValue = this.baseMsg[this.baseMsg.length - 1].content
      this.$children.nickname = this.baseMsg[this.baseMsg.length - 2].content
    },
    cancelFn () {
      this.isEdit = !this.isEdit
    },
    historyFn () {
      const params = sensorHistoryQueryFormat(this.detailObj)
      sensorHistory(params)
    },
    handleTabs (name) {
      this.TabsActive = name
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 900px;
}

.contentDio {
  max-height: 700px;
  box-sizing: border-box;
  overflow: auto;

  .detailMsg {
    display: flex;
  }

  .msgContent {
    li {
      line-height: 30px;
    }
  }

  .m15 {
    margin: 15px 0;
  }

  ::v-deep .el-textarea__inner {
    border-radius: 2px;
    // margin-left: 5px;
  }
}

</style>
